import { VoteTier } from '../types/vote';

export const voteTiers: VoteTier[] = [
  {
    votes: 1,
    amount: 100,
    bonus: 0
  },
  {
    votes: 5,
    amount: 450,
    bonus: 1
  },
  {
    votes: 10,
    amount: 850,
    bonus: 3
  },
  {
    votes: 20,
    amount: 1500,
    bonus: 8
  }
];